import PropTypes from 'prop-types';

const Experiment = ({ variants, placeholder, selectedVariantName }) => {
  return variants[selectedVariantName] || placeholder;
};

Experiment.propTypes = {
  variants: PropTypes.object,
  placeholder: PropTypes.node,
  selectedVariantName: PropTypes.string,
};

Experiment.defaultProps = {
  placeholder: null,
};

export default Experiment;
